module.exports = __webpack_public_path__ + "img/platforms4.bfecadeb.png";